import React from 'react'
import PrivatePageSF from '../../templates/PrivatePageSF.js'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import EmptyListUI from '../../widgets/output/EmptyListUI'
import OrderListUI from '../../components/finapp/order/OrderListUI'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'

const OrderListPageUI = ({context, messageList, errorList, orderList, filteredOrderList,
    alphaSort, timeSort, statusList, searchFilter,
    onRefreshClick, onAlphaSortClick, onTimeSortClick,
    onStatusFilterChange, onSearchFilterChange
  }) =>
  <PrivatePageSF context={context} className='pg_orders'
    messageList={messageList} headerMessageKey='c_cust_orders'
    centered={(!orderList && !errorList) || (orderList && orderList.length === 0)}
  >
    {
      (!orderList || !statusList) && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      orderList && orderList.length === 0 && statusList &&
      <EmptyListUI
        context={context}
        messageList={messageList}
        createEnabled={context.permissions && context.permissions.includes('acc_manage')}
        createLink='/orders/create'
        createLinkKey='c_create_order'
        createDisabledMessageKey='c_no_order_msg'
      />
    }
    {
      orderList && filteredOrderList && orderList.length !== 0 && statusList &&
      <div>
        <PageTitleUI context={context} messageList={messageList} titleMessageKey='c_cust_orders' />
        <OrderListUI
          context={context}
          orderList={filteredOrderList}
          messageList={messageList}
          alphaSort={alphaSort}
          timeSort={timeSort}
          statusList={statusList}
          searchFilter={searchFilter}
          // events
          onRefreshClick={onRefreshClick}
          onAlphaSortClick={onAlphaSortClick}
          onTimeSortClick={onTimeSortClick}
          onStatusFilterChange={onStatusFilterChange}
          onSearchFilterChange={onSearchFilterChange}
        />
      </div>
    }
  </PrivatePageSF>

export default OrderListPageUI
